import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useCreate: useCreateStudentApplicationAdmit } = getCRUDHooks({
  entityName: 'studentApplicationAdmit',
  create: (
    values: { grantedPathId: number; grantedProgram: string },
    { studentApplicationId }: { studentApplicationId: string }
  ) =>
    clientApi
      .getOCClient()
      .helpers.studentApplication.studentApplication.id(studentApplicationId)
      .admit.create(values),
});

export {
  // eslint-disable-next-line import/prefer-default-export
  useCreateStudentApplicationAdmit,
};
